import { useContext } from "react";
import { AppContext, Environment } from "../app";

export default function usePendoTrackEvent() {
  const { environment } = useContext(AppContext);
  return (name: string) => {
    if (environment === Environment.Production && typeof pendo !== "undefined" && pendo.isReady) {
      return pendo.track(name);
    }
  };
}
